/* eslint-disable arrow-body-style */
import _ from 'underscore';
import React, { useCallback, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { ChoiceGroup } from '@bingads-webui-react/fabric-control';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';

import { CustomDropdown } from '../custom-dropdown-component';
import { getLocationFilterStyle } from './style';

export const SearchLocationFilter = ({
  defaultLocation,
  locationFilterOptions,
  dropdownWidth,
  onChange,
  onDismiss,
  focused,
  i18n,
}) => {
  //
  const [locationFilter, setLocation] = useState(defaultLocation);
  const classes = useDefaultStyles(getLocationFilterStyle);

  // choice group handling
  const selectedChoice = useMemo(
    () => _.find(locationFilterOptions, r => r.key === locationFilter),
    [locationFilter, locationFilterOptions]
  );

  const onLocationChange = useCallback((evt, option) => {
    if (option && option.key) {
      setLocation(option.key);
    }
  }, []);

  // the string shown on dropdown title
  const dropdownTitle = selectedChoice ? selectedChoice.title : null;

  // when the X button on dropdown title is clicked
  const onDropdownClear = useCallback((isDropdownOpen) => {
    setLocation(null);
    if (!isDropdownOpen && onChange && defaultLocation !== null) {
      onChange(null);
    }
  }, [defaultLocation, onChange]);

  // when dropdown list is dismissed
  const onDropdownDismiss = useCallback(() => {
    if (onChange && defaultLocation !== locationFilter) {
      onChange(locationFilter, dropdownTitle);
    }
    if (onDismiss) {
      onDismiss(locationFilter, dropdownTitle);
    }
  }, [onChange, defaultLocation, locationFilter, onDismiss, dropdownTitle]);

  return (
    <CustomDropdown
      title={dropdownTitle}
      placeholder={i18n.getString(_TL_('Location'))}
      dropdownWidth={dropdownWidth}
      onClear={onDropdownClear}
      onDismiss={onDropdownDismiss}
      focused={focused}
    >
      <div className={classes.locationFilterDowndown}>
        <div className={classnames(classes.dropdownTitle, 'dropdown-title')}>{i18n.getString(_TL_('Location'))}</div>
        <ChoiceGroup
          className={classes.dropdownLocationChoice}
          selectedKey={selectedChoice ? selectedChoice.key : ''}
          options={locationFilterOptions}
          onChange={onLocationChange}
        />
      </div>
    </CustomDropdown>
  );
};

SearchLocationFilter.propTypes = {
  defaultLocation: PropTypes.string,
  locationFilterOptions: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string,
    text: PropTypes.string,
  })).isRequired,
  onChange: PropTypes.func,
  onDismiss: PropTypes.func,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  dropdownWidth: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  focused: PropTypes.bool,
};

SearchLocationFilter.defaultProps = {
  defaultLocation: null,
  onChange: undefined,
  onDismiss: undefined,
  dropdownWidth: 0,
  focused: false,
};
